import CrashBoardContent from '@/components/Crash/VideoPlayer/Board/Content';
import { RoundStatus } from '@/models/round/status';
import { useMemo } from 'react';
import { GameReportBoardRound } from '../props';
import styles from './styles.module.scss';

export default function CrashGameReportBoard({ round }: GameReportBoardRound) {
  function getLines() {
    const multiplier = round?.crash?.crashpoint?.toNumber();

    const result: number[] = [];

    if (result.length === 0) {
      result.push(0);
    }

    result.push(multiplier / 3);
    result.push(multiplier);

    return result;
  }

  const lines = useMemo(getLines, [round?.crash?.crashpoint]);

  return (
    <div className={styles.container}>
      <CrashBoardContent
        lines={lines}
        round={round}
        status={round?.status as unknown as RoundStatus}
      />
    </div>
  );
}
